export const INTERVENTIONS_MINIMAL_FIELDS = `
  fragment interventionsMinimalFields on interventions {
    id
    date
    number
    type
  }
`;
